import React, { useCallback, useEffect, useState } from 'react'
import PesadoDestareChofer0 from './steps/PesadoDestareChofer0'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_PESO_DESTARE } from '../../../../config/forms'
import { INTERVALO_LARGO } from '../../../../config/settings'

function PesadoDestareChofer (props) {
  const { cpe, pesoCabezal, showReimpresion, modo } = props
  const [show, setShow] = useState(false)
  const [init, setInit] = useState(false)
  const [timer, setTimer] = useState(0)

  const onBlurInput = useCallback(() => {
    if (!show && !cpe && timer === 0 && !props.numero) {
      if (document.getElementsByName('numero')[0]) {
        document.getElementsByName('numero')[0].focus()
      }
    }
  }, [cpe, props.numero, show, timer])

  const borrarCpeDestare = useCallback((numero) => {
    const { change: formChange } = props
    setShow(false)
    props.deleteCpeEnDestare(numero)
    props.updateCpeDestare(null)
    props.resetConsultaCeaDestare()
    formChange('numero', '')
  }, [props])

  useEffect(() => {
    function setUp () {
      onBlurInput()
      props.queryParametrosDestare()
      props.getCpeEnDestare()
      props.setShowFooterPesado(true)
    }

    const intervalParametros = setInterval(async () => {
      const { cpe } = props
      if (!cpe) {
        const parametros = await props.queryParametrosDestare()
        console.log(parametros)
      }
    }, INTERVALO_LARGO)

    const intervalPesoCabezal = setInterval(async () => {
      const { change: formChange, pesoMinimo, diferenciaTara, repeso } = props

      onBlurInput()
      props.getCpeEnDestare()

      // control para dar tiempo a recibir cpe y que no se cierre el dialogo
      if (timer > 0) {
        setTimer(timer => timer - 1)
      }

      if (cpe && !diferenciaTara) {
        props.calcularDiferenciaPesoTara(cpe.pesoTaraOrigen, cpe.pesoTara)
      }

      // ---> MODO AUTO
      if (modo === 'auto') {
        const peso = await props.requestPesoDestare()
        formChange('pesoDestare', peso && peso)
        props.escribirPesoDestare(peso)

        if (repeso === 1) {
          props.requestPesoDestareSinEquilibrio()
          const peso = await props.requestPesoDestare()
          formChange('pesoDestare', peso && peso)
        }

        // modo auto && no hay camion en balanza
        if (parseInt(pesoCabezal) < parseInt(pesoMinimo)) {
          if (show) {
            setShow(false)
            formChange('numero', '')
          }
          if (cpe && cpe.numero) {
            borrarCpeDestare(cpe.numero)
            // props.updateConsultaCea(null)
            formChange('numero', '')
            setShow(false)
            const parametros = await props.queryParametrosDestare()
            console.log(parametros)
          }
          if (repeso === 1) {
            props.updateEnclavamiento(1)
            props.updateParametroInteger('REPESODE', 0)
          }
        }
      }

      // si esta en modo manual o hay camión en la balanza
      if (modo === 'manual' || (parseInt(pesoCabezal) && parseInt(pesoCabezal) > parseInt(pesoMinimo))) {
        if (cpe && !show && !cpe.error) {
          setShow(true)
          setTimer(1)
        }

        if (!cpe && show && timer === 0) {
          setShow(false)
          formChange('numero', '')
          setTimer(0)
        }

        if (!cpe && repeso) {
          // Llamo al rearead para actualizar el peso que quedo fijo porque
          // se leyo una carta de porte y no se llego al equilibrio
          const peso = await props.requestPesoDestareSinEquilibrio()
          formChange('pesoDestare', peso && peso)
        }

        if (!cpe && repeso) {
          const parametros = await props.queryParametrosDestare()
          console.log(parametros)
        }
      }

      if (!cpe && show && timer === 0) {
        setShow(false)
        const parametros = await props.queryParametrosDestare()
        console.log(parametros)
        formChange('numero', '')
      }

      if ((!showReimpresion) && diferenciaTara && (diferenciaTara > pesoMinimo)) {
        props.updateShowReimpresionDestare(true)
      }
    }, [2000])

    if (!init) {
      setUp()
      setInit(true)
    }

    return () => {
      clearInterval(intervalPesoCabezal)
      clearInterval(intervalParametros)
    }
  }, [props, show, timer, borrarCpeDestare, cpe, init, onBlurInput, pesoCabezal, modo, showReimpresion])

  const updateShowDestare = (newValue) => {
    setShow(newValue)
  }

  const reimprimirTicket = (numero) => {
    props.reimprimirTicketDescarga(numero)
  }

  const reimprimirUltimoTicketDescarga = () => {
    props.reimprimirUltimoTicketDescarga()
  }

  const reimpresionCerealAdherido = (numero) => {
    props.reimpresionCerealAdherido(numero)
  }

  const handleSubmit = async (e) => {
    const { pesoCabezal, pesoMinimoDestare, change: formChange, repeso, numero, modo } = props
    e.preventDefault()

    if (modo === 'auto') {
      if ((!isNaN(numero)) && (String(numero).length === 11) && ((pesoCabezal > pesoMinimoDestare))) {
        if (repeso === 1) {
          props.submitPesadoDestare(true, formChange)
        } else {
          props.submitPesadoDestare(false)
        }
        setShow(true)
        setTimer(1)
      } else {
        formChange('numero', '')
      }
    } else {
      console.log('TODO: modo manual desde totem ')
    }
  }

  return (
    <div>
      <PesadoDestareChofer0
        show={show}
        cpe={cpe}
        pesoCabezal={pesoCabezal}
        showReimpresion={showReimpresion}
        reimprimirUltimoTicket={reimprimirUltimoTicketDescarga}
        reimpresionCerealAdherido={reimpresionCerealAdherido}
        reimprimirTicket={reimprimirTicket}
        handleSubmit={handleSubmit}
        borrarCpeDestare={borrarCpeDestare}
        modo={modo}
        onBlurInput={onBlurInput}
        updateShowDestare={updateShowDestare}
        // estadoBarreras={props.estadoBarreras}
      />
    </div>
  )
}

const selector = formValueSelector(FORM_PESO_DESTARE)

const mapStateToProps = (state) => {
  return {
    cpe: state.pesado.cpePesadoDestare || null,
    pesoCabezal: selector(state, 'pesoDestare'),
    pesoMinimoDestare: state.pesado.pesoMinimoDestare,
    pesoMinimo: state.pesado.pesoMinimoDiferenciaDestare,
    diferenciaTara: state.pesado.diferenciaTara,
    showReimpresion: state.pesado.showReimpresionDestare,
    urlDestare: state.pesado.urlDestare,
    printerDestare: state.pesado.printerDestare,
    numero: selector(state, 'numero'),
    enclavamiento: state.pesado.enclavamientoDestare,
    repeso: state.pesado.repesoDestare,
    modo: state.pesado.pesajeDestare
    // estadoBarreras: state.pesado.estadoBarrerasDestare
  }
}
const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PESO_DESTARE,
  destroyOnUnmount: false,
  keepDirtyOnReinitialize: false
})

export default withRedux(withReduxForm(PesadoDestareChofer))
